import { DatabaseAccessUtils } from '../model/database-access-utils'

/**
 * Exposes the pure {@link DatabaseAccessUtils} helpers to the component layer
 * (the MVVM-blessed indirection over same-package `model/`).
 */
export function useDatabaseAccessUtils() {
  return { DatabaseAccessUtils }
}
